import { render, staticRenderFns } from "./UpdateBusinessForm.vue?vue&type=template&id=74cc92f3&scoped=true"
import script from "./UpdateBusinessForm.vue?vue&type=script&lang=js"
export * from "./UpdateBusinessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cc92f3",
  null
  
)

export default component.exports